import { DialogContent } from '@mui/material'
import React from 'react'

import Dialog from '@/app/component/atom/dialog'
import DialogHeader from '@/app/component/atom/dialog-header'

import ProformaInvoice from './proforma-invoice'

type Props = {
  onClose: () => void
}

const ProformaInvoiceDialog: React.FC<Props> = ({ onClose }) => (
  <Dialog open onClose={onClose}>
    <DialogHeader icon="receipt_long" title="Proforma Invoice" onClose={onClose} />
    <DialogContent>
      <ProformaInvoice onSuccess={onClose} />
    </DialogContent>
  </Dialog>
)

export default ProformaInvoiceDialog
